import { fileUrl } from "./api";

export const HERO_FALLBACK_IMAGE =
    "https://images.unsplash.com/photo-1663900108404-a05e8bf82cda?fm=jpg&q=80&w=1800&auto=format&fit=crop";

export const TAWAF_FALLBACK_IMAGE =
    "https://images.unsplash.com/photo-1541625602330-2277a4c46182?fm=jpg&q=80&w=1600&auto=format&fit=crop";

export function workCoverUrl(work) {
    if (!work) return "";
    if (work.cover_image) return fileUrl(work.cover_image);

    const slug = String(work.slug || "").toLowerCase();
    const title = `${work.title_en || ""} ${work.title_ar || ""}`.toLowerCase();
    if (slug.includes("saudi-tour") || title.includes("tawaf") || title.includes("tour")) {
        return TAWAF_FALLBACK_IMAGE;
    }

    return "";
}
